exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-subheader{padding:25px 20px 0 20px;display:flex}.c-subheader_title{display:inline-block;padding:7px 25px 7px 0;font-weight:500;vertical-align:middle;margin:0 15px 0 0;font-size:18px;color:#112363}", ""]);

// exports
